import { SVGProps } from 'react'

export const FileFolderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z"
      fill="#01A4FE"
    />
    <path
      opacity="0.3"
      d="M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z"
      fill="white"
    />
    <path
      d="M20.6666 20.6667L19.923 19.1793C19.7089 18.7512 19.6019 18.5372 19.4422 18.3808C19.301 18.2425 19.1309 18.1373 18.944 18.0729C18.7328 18 18.4935 18 18.0148 18H15.4666C14.7199 18 14.3465 18 14.0613 18.1453C13.8104 18.2732 13.6065 18.4771 13.4786 18.728C13.3333 19.0132 13.3333 19.3866 13.3333 20.1333V20.6667M13.3333 20.6667H23.4666C24.5868 20.6667 25.1468 20.6667 25.5746 20.8847C25.951 21.0764 26.2569 21.3824 26.4487 21.7587C26.6666 22.1865 26.6666 22.7466 26.6666 23.8667V26.8C26.6666 27.9201 26.6666 28.4802 26.4487 28.908C26.2569 29.2843 25.951 29.5903 25.5746 29.782C25.1468 30 24.5868 30 23.4666 30H16.5333C15.4132 30 14.8532 30 14.4253 29.782C14.049 29.5903 13.743 29.2843 13.5513 28.908C13.3333 28.4802 13.3333 27.9201 13.3333 26.8V20.6667Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
